module.exports = __webpack_public_path__ + "static/media/tcb-logo.ec9e17ec.png";